/*
 * Enum.
 */

export enum BulkActionTypesEnum {
  ARCHIVE,
  REOPEN,
  SNOOZE,
  UNSNOOZE,
  TRASH,
  MOVE,
  ASSIGN,
  UNASSIGN,
  TAG,
  UNTAG,
  STAR,
  UNSTAR,
  MARK_UNREAD,
  MARK_READ,
  SPAM,
}
